/**
 * Busca un mensaje por código en el objeto eMessages
 * @param {object} context - El contexto de la aplicación
 * @param {string|number} code - El código a buscar
 * @returns {string} - El mensaje correspondiente al código o el código si no se encuentra
 */
const findMessageByCode = (context, code) => {
  const isNumeric = !isNaN(code) && !isNaN(parseFloat(code))

  if (!isNumeric) {
    return code
  }

  const numericCode = parseInt(code, 10)

  // Obtener los mensajes de backend
  const eMessages = context.$t('backend.EMessage')
  console.log('EMESSAGES:', eMessages)
  if (!eMessages || typeof eMessages !== 'object') {
    return code
  }

  // Buscar el mensaje por código
  for (const key in eMessages) {
    if (Object.prototype.hasOwnProperty.call(eMessages, key)) {
      const messageObj = eMessages[key]
      if (messageObj && messageObj.code === numericCode) {
        return messageObj.message
      }
    }
  }

  return code
}

/**
 * Resuelve variables de idioma y maneja casos especiales
 * @param {object} context - El contexto de la aplicación
 * @param {string|object} key - La clave de traducción o un objeto con propiedad code
 * @param {object} keyValues - Valores para reemplazar en la traducción
 * @returns {string} - La traducción procesada
 */
const langVarsResolver = (context, key, keyValues = {}) => {
  // Si key es un objeto con propiedad code, extraer el código
  if (key && typeof key === 'object' && 'code' in key) {
    return findMessageByCode(context, key.code)
  }

  let keyValue = context.$t(key)

  if (!keyValue || keyValue === key) {
    const prefixedKey = `backend.ENotice.${key}`
    keyValue = context.$t(prefixedKey)

    if (!keyValue || keyValue === prefixedKey) {
      return findMessageByCode(context, key)
    }
  }

  // Reemplazar variables en la traducción
  for (const keyObject in keyValues) {
    if (Object.prototype.hasOwnProperty.call(keyValues, keyObject)) {
      const value = keyValues[keyObject]
      keyValue = keyValue.replaceAll(`{{${keyObject}}}`, value)
    }
  }

  return keyValue
}

export default langVarsResolver
